import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoggedIn: !!localStorage.getItem('token'),
    user: [],
    dataitinerari: [],
  },
  mutations: {
    setUser(state, data) {
      state.user = data
    },
    UpdateFoto(state, data) {
      state.user.img = data
    },
    setDataItinerari(state, data) {
      state.dataitinerari = data
    },
  },
  actions: {},
  modules: {},
  plugins: [createPersistedState({
    storage: window.localStorage,
  })],
})
